import { render } from "./AccountingGeneralAccounts.vue?vue&type=template&id=244fb349&scoped=true&ts=true&lang=pug"
import script from "./AccountingGeneralAccounts.vue?vue&type=script&lang=ts"
export * from "./AccountingGeneralAccounts.vue?vue&type=script&lang=ts"

import "./AccountingGeneralAccounts.vue?vue&type=style&index=0&id=244fb349&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244fb349"]])

export default __exports__